import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'belender-page-layout',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent {

  @Input() mode: 'card' | 'simple' = 'simple';

  @HostBinding('class') get hostClass() {
    return 'belender-page-layout';
  }

  @HostBinding('class.belender-page-layout-card')
  get isCard() {
    return this.mode === 'card';
  }

  @HostBinding('class.belender-page-layout-simple')
  get isSimple() {
    return this.mode === 'simple';
  }

}
